import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  holeProcessContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: 16,

    '& .hole-process__search': {
      display: 'flex',
      alignItems: 'center',
      height: 'auto',
      boxShadow: '0 0 15px 0px rgb(111 72 65 / 0.15)',
      borderRadius: 8,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      '& p': {
        color: '#513628',
        fontSize: 16,
        margin: '6px 0 0 8px'
      },
      '& button': {
        height: 35,
        margin: '0 8px 0 0',
        width: 'auto',
        minWidth: 150,
        '& img': {
          marginRight: 8
        }
      },
      '& i': {
        marginRight: 8,
        border: '0.10em solid #513628',
        borderTop: 'none',
        borderLeft: 'none',
        padding: 3,
        background: '#fff'
      },
      '& input': {
        width: '75%',
        height: 16,
        fontSize: 16,
        margin: '16px 0 8px 8px',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        border: '0.10em solid #513628',
        '&:focus': {
          outline: 0
        },
      },
    },
  },

  holeProcessDivider: {
    width: '45%',
    display: 'none',
    '@media (min-width:436px)': {
      display: 'unset'
    }
  },

  holeProcessTableActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    height: 5,
    '& img': {
      cursor: 'pointer',
    },
  },

  holeProcessPopup: {
    '& .popup__box': {
      height: 'auto!important',
      maxHeight: '880px!important',
      overflow: 'auto',
    },
  },

  holeProcessTitle: {
    width: 200,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight,
  },

  holeProcessHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:436px)': {
      paddingRight: 0,
      display: 'inline-flex',
    }
  },

  holeProcessButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& button': {
      width: '100%',
      margin: '8px 16px 16px 0',
      '& img': {
        marginRight: 8
      }
    },
    '@media (min-width:436px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      },
    }
  },


  genotypingHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',


    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  genotypingHeaderBtnContainer: {
    display: 'flex',
    paddingLeft: 16,
    gap: 10,

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap',
      width: '100%',
      flexDirection: "column"
    }
  },

  genotypingHeaderBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'transparent',
    width: 118,
    height: 40,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: theme.palette.primary.main,
    fontWeight: 800,
    color: theme.palette.primary.main,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },



}))
